import { render, staticRenderFns } from "./TransformationsModal.vue?vue&type=template&id=c919bd3a"
import script from "./TransformationsModal.vue?vue&type=script&lang=js"
export * from "./TransformationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c919bd3a')) {
      api.createRecord('c919bd3a', component.options)
    } else {
      api.reload('c919bd3a', component.options)
    }
    module.hot.accept("./TransformationsModal.vue?vue&type=template&id=c919bd3a", function () {
      api.rerender('c919bd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/edit-page/import/transformations/TransformationsModal.vue"
export default component.exports